import api from '../services/api';
import { getCSRF } from './getCSRF';


export default async function postCurso(url,json) {

  let csrf = await getCSRF();

  return api
    .post(url, json,
    {
      headers: { 'Content-Type': 'application/json', "X-CSRFToken": csrf?.csrfToken,},
    })
    .then(response => {
      return {type: 'success', data: response.data};
    })
    .catch(error => {
      return {type:'error', data: {code: error.response.data.code, detail: error.response.data.detail}}
    });
}
